import clsx from 'clsx';
import { Children, ReactNode, useMemo } from 'react';
import { Divider } from '../Divider/Divider';
import s from './Divided.module.scss';

interface ColumnsProps {
    direction?: 'vertical' | 'horizontal';
    children?: ReactNode;
    className?: string;
    dividerClassName?: string;
}

export function Divided({
    direction = 'vertical',
    children,
    className,
    dividerClassName,
}: ColumnsProps): ReactNode {
    const classes = clsx(s.divided, className, {
        'flex-column': direction === 'horizontal',
    });

    const divider = useMemo(
        () => (
            <Divider
                className={dividerClassName}
                type="solid"
                layout={direction}
            />
        ),
        [direction, dividerClassName],
    );

    const content = useMemo(() => {
        if (!children) {
            return children;
        }
        if (typeof children === 'string') {
            return children;
        }
        return Children.toArray(
            Children.map(children, (n) => [n, divider]),
        ).slice(0, -1);
    }, [children, divider]);

    return <div className={classes}>{content}</div>;
}
